import React, { useState, useEffect, useRef } from 'react';
import AddFunds from './AddFunds';
import { useAppData } from '../../redux/appDataProvider';
import { useSelector } from 'react-redux';
import ApiClient from '../../utilities/apiClient';
import AppConfig from '../../AppConfig';
import * as CryptoJS from 'crypto-js';

const AddFundsController = () => {
  const { userInfo, setUserInfo } = useAppData(null);
  const { userBanks = [], setUserBanks } = useAppData(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [amount, setAmount] = useState(null);
  const [paymentMode, setPaymentMode] = useState("upi");
  const apiToken = useSelector(state => state.auth.apiToken);
  const pg = useSelector(state => state.auth.pg);
  const userId = useSelector(state => state.auth.userId);
  const [paymentData, setPaymentData] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentOrderId, setPaymentOrderId] = useState(null);
  const [paymentTxId, setPaymentTxId] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState(null);
  const { razorKey, setRazorKey } = useAppData();
  const { cryptoSecret, setCryptoSecret } = useAppData();
  const [paymentList, setPaymentList] = useState([]);
  const [showlodder, setShowLodder] = React.useState(false);

  const [errtype, setErrorType] = useState(0);
  const [errmsg, setErrMsg] = useState('');
  const [upiPaymentfail, setUpiPaymentFail] = useState(false)
// useRef code added in many lines to hide key board - 02-08-2024 -Dev Srini
  const amountRef = useRef(null)

  useEffect(() => {
    if (userBanks?.length == 1) {
      setSelectedBank(userBanks[0])
    } else {
      const defaultBank = userBanks?.length > 0 && userBanks.find(ele => ele.Default_Ac == "Yes")
      setSelectedBank(defaultBank)
    }

  }, [userBanks])

  const fetchUserInfo = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Client.info,
        "POST",
        {
          "ClientCode": userId,
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if (response && response.Success == "True" && response.hasOwnProperty("Success Description")) {
            let responseData = response["Success Description"];
            console.info(`data ${responseData}`);
            if (Array.isArray(responseData) && responseData.length > 0) {
              console.info(`setUserInfo ${responseData[0]}`);
              setUserInfo(responseData[0]);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  const getPaymentInfo = async () => {
    try {
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Payment.info,
        "POST",
        {
          "userId": userId,
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          response.cryptoSecret && setCryptoSecret(response.cryptoSecret);
          response.key && setRazorKey(response.key);
          setPaymentStatusModel(response.cryptoSecret);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  const handleBankChange = (event, newValue) => {
    setSelectedBank(newValue);
  };
  const handleRetry = (event, newValue) => {
    setPaymentData(null);
  };
  const handlePaymentSuccess = (event, newValue) => {
    setPaymentSuccess(false);
  };
  const handleAmountValueChange = (values) => {
    setAmount(values.substring(2));
  };

  const handlePaymentModeChange = (value) => {
    console.info(`paymentMode ${value}`);
    setPaymentMode(value.target.value);
  };
  const fetchPaymentList = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";
      setShowLodder(true)
      const apiClient = new ApiClient(apiToken);
      apiClient.fetchData(
        AppConfig.api.Payment.list,
        "POST",
        {
          "Client_id": userId,
        })
        .then((response) => {
          setShowLodder(false)

          let responseData = response

          if (Array.isArray(responseData) && responseData.length > 0) {
            console.info(`Payment LIst ${responseData}`);
            setPaymentList(responseData);
          }

        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  };

  const callRecieptEntry = async () => {
    try {
    } catch (error) {
      console.error('Error while updating the reciept:', error);
    }
  };

  const axisbank = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";

      const apiClient = new ApiClient(apiToken);
      if (!selectedBank) {
        setErrMsg("Please select a bank!");
        setErrorType(1)
        return;
      }
      if (!amount) {
        setErrMsg("Please enter amount!");
        setErrorType(2)
        return;
      }
      if (parseFloat(amount.replaceAll(",",""))<25) {
        setErrMsg("Minimum amount allowed is Rs 25");
        setErrorType(2)
        return;
      }
      
      if(paymentMode==="netbanking")
      {
        if (parseFloat(amount.replaceAll(",",""))>10000000) {
          // Srini - 19/11/24
          setErrMsg("Maximum  amount allowed is Rs 1 Crore.");
          setErrorType(2)
          return;
        }
      }else{
      if (parseFloat(amount.replaceAll(",",""))>200000) {
        // Srini - 19/11/24
        setErrMsg("Maximum amount allowed for UPI  is Rs 2 Lakhs.");
        setErrorType(2)
        return;
      }}
      setShowLodder(true)
      // reset error when value is true -30-07-24 - Dev Srini
      setErrMsg("")
      apiClient.fetchData(
        AppConfig.api.Payment.payOrder,
        "POST",
        {
          "accountNumber": selectedBank.Bank_AcNo,
          "name": userInfo.CLIENT_NAME,
          "ifsc": selectedBank.IFSC_Code,
          "phone": selectedBank.MOBILE_NO,
          "email": userInfo.CLIENT_ID_MAIL,
          "amount": amount,
          "userId": userId,
          "paymentMode": paymentMode,
          "upiid": selectedBank.UPIBANKID,
          "bankname": selectedBank.Bank_Name
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if (response && response.success == true && response.hasOwnProperty("orderId")) {
            const methodsObj = AppConfig.paymentGateWay.methodsObj[paymentMode];
            console.info(methodsObj);

            const options = {
              key: razorKey, // Enter the Key ID generated from the Dashboard
              amount: amount,
              currency: AppConfig.paymentGateWay.currency,
              name: AppConfig.paymentGateWay.name,
              description: "Add Funds",
              method: paymentMode,
              order_id: response.orderId,
              redirect: true,
              callback_url: `${AppConfig.baseUrl}payment/paystatus?orderId=${response.orderId}&userId=${userInfo.CLIENT_ID}`,
              // handler: async function (response1) {
              //     this.getaxis(response1)
              // },
              options: {
                checkout: {
                  method: {
                    // "netbanking": 1, // check it according to the user selection 
                    // "card":1,
                    // "upi":0,
                    // "wallet":0
                  }
                }
              },
              // prefill updated by Srini 04-11-24
              prefill: {
                name: userInfo.CLIENT_NAME,
                email: userInfo.CLIENT_ID_MAIL,
                contact: selectedBank.MOBILE_NO,
                ...(paymentMode === 'upi'&& {method: paymentMode}),
                ...(paymentMode === 'upi'&& {vpa: selectedBank.UPIBANKID})
              },
              theme: {
                color: AppConfig.paymentGateWay.theme.color,
              },
            };

            switch (paymentMode) {
              case 'netbanking':
                options.options.checkout.method.netbanking = 1;
                break;
              case 'upi':
                options.options.checkout.method.upi = 0;
                break;
            };
            const paymentObject = new window.Razorpay(options);
            console.log("CHEKINGRAZORPAY", options)
            paymentObject.on('payment.failed', function (response) {
              // alert(response.error.metadata.payment_id);
              setPaymentOrderId(response.error.metadata.order_id);
              setPaymentErrorMessage(response.error.reason);
              setUpiPaymentFail(true)
              setPaymentSuccess(false)
            });

            paymentObject.on('order.paid', function (response) {
              alert(response)
            });
            paymentObject.open();
          }
          // Amount exceed error - 20/11/24 - Srini
          else if(response.status === 400 && response.data.success == false){
            setPaymentData({status : 'Failure'})
            setPaymentErrorMessage(response.data.message)
            setPaymentAmount(amount)
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }

  const atombank = async () => {
    try {
      // Replace this with your actual data fetching logic
      // const apiToken ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEwMzQsImlhdCI6MTcxMTM1MTIxNywiZXhwIjoxNzExMzUzMDE3fQ.W6yAyoTXBefesvAMWN-2MuxVlS1d33l7d_ZGIKUMDcU";

      const apiClient = new ApiClient(apiToken);
      if (!selectedBank) {
        setErrMsg("Please select a bank!");
        setErrorType(1)
        return;
      }
      if (!amount) {
        setErrMsg("Please enter amount!");
        setErrorType(2)
        return;
      }
      setShowLodder(true)
      apiClient.fetchData(
        AppConfig.api.Payment.pg_payOrder,
        "POST",
        {
          "accountNumber": selectedBank.Bank_AcNo,
          "name": userInfo.CLIENT_NAME,
          "ifsc": selectedBank.IFSC_Code,
          "phone": selectedBank.MOBILE_NO,
          "email": userInfo.CLIENT_ID_MAIL,
          "amount": amount,
          "userId": userId,
          "paymentMode": paymentMode,
          "upiid": selectedBank.UPIBANKID,
          "bankname": selectedBank.Bank_Name
        })
        .then((response) => {
          console.info(response);
          setShowLodder(false)
          if (response && response.success == true && response.hasOwnProperty("url")) {

            console.log('PG', response.url)
            window.open(response.url, '_self')

          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error('Error fetching holding data:', error);
    }
  }
  const handleAddFundsSubmit = async () => {
    
    // Hide the keyboard
    console.log(amountRef.current, "Hide the keyboard")
    if (amountRef.current) {
      amountRef.current.blurInput();
    }

    if (pg === "AXIS") {
      axisbank()
    }

    if (pg === "ATOM") {
      atombank()
    }
  };

  const handleUpiPaymentFail = () =>{
    setUpiPaymentFail(false)
  }

  const setPaymentStatusModel = (secret) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const encodedData = urlParams.get('data') || null;
    const decryptedData = encodedData ? CryptoJS.AES.decrypt(decodeURIComponent(encodedData), secret).toString(CryptoJS.enc.Utf8) : null;
    const parsedData = decryptedData && JSON.parse(decryptedData);
    parsedData && setPaymentData(parsedData);
    if (parsedData && (parsedData.status === 'Success' || parsedData.status === 'Failure')) {
      parsedData.status === 'Success' ? setPaymentSuccess(true) : setPaymentSuccess(false);
      setPaymentOrderId(parsedData.orderid);
      parsedData.trackingId && setPaymentTxId(parsedData.trackingId);
      parsedData.message && setPaymentTxId(parsedData.message);
      setPaymentAmount(parsedData.amount);
      // parsedData.status === 'Success' && callRecieptEntry(parsedData);
      AppConfig.removeQueryParams();
    }
  };

  useEffect(() => {
    getPaymentInfo();
    // fetchUserBanks();
    fetchUserInfo();
    fetchPaymentList()
  }, []); // Empty dependency array to fetch data only once on component mount

  return <AddFunds
    userInfo={userInfo}
    userBanks={userBanks}
    selectedBank={selectedBank}
    paymentMode={paymentMode}
    paymentSuccess={paymentSuccess}
    paymentOrderId={paymentOrderId}
    paymentTxId={paymentTxId}
    paymentAmount={paymentAmount}
    paymentData={paymentData}
    paymentErrorMessage={paymentErrorMessage}
    handleRetry={handleRetry}
    handlePaymentSuccess={handlePaymentSuccess}
    handlePaymentModeChange={handlePaymentModeChange}
    handleBankChange={handleBankChange}
    handleAmountValueChange={handleAmountValueChange}
    handleAddFundsSubmit={handleAddFundsSubmit}
    paymentList={paymentList}
    showlodder={showlodder}
    errmsg={errmsg}
    errtype={errtype}
    upiPaymentfail={upiPaymentfail}
    handleUpiPaymentFail={handleUpiPaymentFail}
    ref={amountRef}
  />;
};
export default AddFundsController;
